import React   from 'react';

class StyledView extends React.Component {

	constructor(props) {
		super(props);
	}

	getBorderStyle() {
		const view  = this.props.view;
		const width = view['border_width'] || '1';
		const color = view['border_color'] || '#000';
		return width + 'px solid ' + color;
	}

	getTableStyle() {
		if (this.props.view['border'] === 'table') {
			return {border: this.getBorderStyle()};
		} else {
			return {};
		}
	}

	getRowStyle() {
		switch (this.props.view.border) {
			case 'rows': 
				return {border: this.getBorderStyle()};
			case 'table':
			case 'cells':
				return {border: 'none'};
			default: 
				return {};
		}
	}

	getCellStyle() {
		switch (this.props.view.border) {
			case 'cells': 
				return {border: this.getBorderStyle()};
			case 'table':
			case 'rows': 
				return {border: 'none'};
			default: 
				return {};
		}
	}

	createCss(col) {
		const css = {};
		if (col['font_size']) {
			css.fontSize = col['font_size'] + 'px';
		}
		if (col['col_foreground']) {
			css.color = col['col_foreground'];
		}
		if (col['col_background']) {
			css.backgroundColor = col['col_background'];
		}
		if (col['font_style']) {
			css.fontStyle = col['font_style'];
		}
		if (col['font_weight']) {
			css.fontWeight = col['font_weight'];
		}
		if (col['col_width']) {
			css.width = col['col_width'];
		}
		if (col['col_width_min']) {
			css.minWidth = col['col_width_min'];
		}
		return css;
	}

}

export default StyledView;
